<div class="label" [ngStyle]="{'background-color': color, 'color': textColor }">
    {{text}}
</div>